import React from 'react';

function StaffNotFound({ inline = false }) {
    return (
        <div className={`flex flex-col items-center justify-center text-offwhite ${inline ? 'py-16' : 'min-h-screen bg-coal_dark'}`}>
            <div className="font-['Jersey_10'] text-[200px] leading-none">
                404
            </div>

            <div className="relative -top-[20px] flex items-start gap-4 font-['Jersey_10'] text-[40px] leading-[36px]">
                <img
                    src={`${process.env.PUBLIC_URL}/img/piccolo.webp`}
                    className="z-5 relative -top-3 h-[87px] w-[32px]"
                    alt=""
                />
                <div className="flex flex-col">
                    <span>Page Not</span>
                    <span>Found</span>
                </div>
            </div>

            <a
                href="/"
                className="mt-6 flex flex-row items-center gap-2 text-[16px] underline"
            >
                Take me home, Frankly roads...
                <img
                    src={`${process.env.PUBLIC_URL}/img/bus.png`}
                    className="h-[31px] w-[32px]"
                    alt=""
                />
            </a>
        </div>
    );
}

export default StaffNotFound;
